import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import 'Layout/NavBar/MegaMenu/MegaMenu.scss';

import SpecialSections from 'Layout/NavBar/MegaMenu/Categories/SpecialSections';
import ActionLinks from 'Layout/NavBar/MegaMenu/Categories/ActionLinks';
import AdventureLinks from 'Layout/NavBar/MegaMenu/Categories/AdventureLinks';
import RolePlayingLinks from 'Layout/NavBar/MegaMenu/Categories/RolePlayingLinks';
import SimulationLinks from 'Layout/NavBar/MegaMenu/Categories/SimulationLinks';
import StrategyLinks from 'Layout/NavBar/MegaMenu/Categories/StrategyLinks';
import SportsRacingLinks from 'Layout/NavBar/MegaMenu/Categories/SportsRacingLinks';
import ThemesLinks from 'Layout/NavBar/MegaMenu/Categories/ThemesLinks';
import PlayStylesLinks from 'Layout/NavBar/MegaMenu/Categories/PlayStylesLinks';

export default function CategoriesMegaMenu({ megaMenuTab, setMegaMenuTab }) {
  return (
    <div
      id="MegaMenu_categories"
      className="container MegaMenuContainer MegaMenuContainer__categories"
      onMouseEnter={() => setMegaMenuTab('categories')}
      onMouseLeave={() => setMegaMenuTab('')}
    >
      <div className={classNames('MegaMenu', { 'MegaMenu--visible': megaMenuTab === 'categories' })}>
        <div className="CategoriesMegaMenu">
          <div className="CategoriesMegaMenu__featuredSection">
            <SpecialSections
              setMegaMenuTab={setMegaMenuTab}
              megaMenuTab={megaMenuTab}
            />
          </div>

          <div className="CategoriesMegaMenu__mainSection">
            <div className="CategoriesMegaMenu__grid">
              <div className="CategoriesMegaMenu__column">
                <div className="CategoriesMegaMenu__link CategoriesMegaMenu__link--title">
                  <Link to="/categories" id="categories-gamegenres" onClick={() => setMegaMenuTab('')}>
                    <FormattedMessage id="categories-mega-menu.link.genres" defaultMessage="Game Genres" />
                  </Link>
                </div>
                <ActionLinks setMegaMenuTab={setMegaMenuTab} />
                <AdventureLinks setMegaMenuTab={setMegaMenuTab} />
              </div>
              <div className="CategoriesMegaMenu__column">
                <div className="CategoriesMegaMenu__link CategoriesMegaMenu__link--title">
                  &nbsp;
                </div>
                <RolePlayingLinks setMegaMenuTab={setMegaMenuTab} />
                <SimulationLinks setMegaMenuTab={setMegaMenuTab} />
              </div>
              <div className="CategoriesMegaMenu__column">
                <div className="CategoriesMegaMenu__link CategoriesMegaMenu__link--title">
                  &nbsp;
                </div>
                <StrategyLinks setMegaMenuTab={setMegaMenuTab} />
                <SportsRacingLinks setMegaMenuTab={setMegaMenuTab} />
              </div>
              <div className="CategoriesMegaMenu__column">
                <ThemesLinks setMegaMenuTab={setMegaMenuTab} />
                <PlayStylesLinks setMegaMenuTab={setMegaMenuTab} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

CategoriesMegaMenu.propTypes = {
  megaMenuTab: PropTypes.string,
  setMegaMenuTab: PropTypes.func,
};

CategoriesMegaMenu.defaultProps = {
  megaMenuTab: '',
  setMegaMenuTab: () => { },
};
